import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

// Account state for the signed-in user. Failure throws so the dashboard can
// fall back to "unknown" (server still gates) rather than showing the
// request-access page on a network blip.
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const response = await api.getMe();
      if (!response.success || !response.data) throw new Error(response.message || 'Failed to load account');
      return response.data;
    },
  });
}
